import { lang } from '../assets/lang'

export default {
  ACTION_BUTTON: lang.action_button_name,
  AUDIO: lang.audio_name,
  BUTTON: lang.button_name,
  CAROUSEL: lang.carousel_name,
  CONDITION: lang.condition_name,
  ECOMMERCE: lang.ecommerce_name,
  CAROUSEL_ITEM: lang.carousel_item_name,
  FACEBOOK_MEDIA: lang.facebook_media_name,
  FILE: lang.file_name,
  GENERIC_TEMPLATE: lang.generic_template_name,
  IMAGE: lang.image_name,
  POSTBACK_NEW: lang.postback_new_name,
  OTN: lang.otn_name,
  RCN: lang.Rcn_name,
  RCN_SINGLE: lang.Rcn_single_name,
  OTN_SINGLE: lang.otn_single_name,
  QUICK_REPLY: lang.quick_reply_name,
  POSTBACK: lang.postback_name,
  SEQUENCE: lang.sequence_name,
  SEQUENCE_SINGLE: lang.sequence_single_name,
  TEXT: lang.text_name,
  OPEN_AI: lang.openai_name,
  HTTP_API: lang.http_api_name,
  TRIGGER: lang.trigger_name,
  USER_INPUT_FLOW: lang.user_input_flow_name,
  USER_INPUT_FLOW_SINGLE: lang.user_input_flow_single_name,
  VIDEO: lang.video_name,
  COMPONENT_LIST: 'Component list',
}